import { User } from "../models/User";
import OCGatewayClient from "../client/OCGatewayClient";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { gatewayUserScopedQueryOptions } from "./gatewayQueryUtils";

let subscribed = false;

export function useDeviceUsersQuery(deviceId: string, accessToken?: string | null) {
    const queryClient = useQueryClient();

    const query = useQuery({
        queryKey: ['getDeviceUsers', deviceId, accessToken].filter(Boolean),
        queryFn: async () => {
            return OCGatewayClient.request('getDeviceUsers', {
                deviceId,
                accessToken
            }) as Promise<User[]>;
        },
        ...gatewayUserScopedQueryOptions,
        staleTime: Infinity,
    });

    if (!subscribed) {
        OCGatewayClient.socket.on('deviceUsersUpdate', (data: any) => {
            queryClient.setQueryData(['getDeviceUsers', data.deviceId], (users: User[] | undefined) => {
                if (!users) {
                    console.log('deviceUsersUpdate (ignored)', data);
                    return;
                }

                if (data.type === 'update') {
                    console.log('deviceUsersUpdate (relevant update)', data);
                    return users.map(user => user.id === data.body.id ? { ...user, ...data.body } : user);
                }

                console.log('deviceUsersUpdate (no match)', data);
                return users;
            });
        });

        subscribed = true;
    }

    return query;
}

export function useDeleteDeviceUserAccessMutation(deviceId: string) {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ['deleteDeviceUserAccess', deviceId],
        mutationFn: async (userId: number) => {
            await OCGatewayClient.request('deleteDeviceUserAccess', {
                deviceId,
                userId
            });
            return userId;
        },
        onSettled: () => {
            queryClient.invalidateQueries({
                queryKey: ['getDeviceUsers', deviceId]
            });
            queryClient.invalidateQueries({
                queryKey: ['getDevice', deviceId]
            });
            queryClient.invalidateQueries({
                queryKey: ['getDevices']
            });
        }
    });
}
